import _ from 'lodash';

export const excludeMainProduct = (variants) => {
  return variants.filter(({ isMainProduct }) => !isMainProduct);
};

export const mapClickMetrics = (selectedProducts, allProducts) => {
  const valueDelimiter = '-';
  const { selectedVariantsIds, podPositions } = selectedProducts.reduce(
    (acc, { variantId }) => {
      const productIndex = allProducts.findIndex((product) => product.variantId === variantId);
      acc.selectedVariantsIds.push(variantId);
      acc.podPositions.push(productIndex + 1);
      return acc;
    },
    {
      selectedVariantsIds: [],
      podPositions: [],
    }
  );
  return {
    selectedVariantsIds: selectedVariantsIds.join(valueDelimiter),
    podPositions: podPositions.join(valueDelimiter),
    podsInCarousel: allProducts,
  };
};

export const isShopTheProjectAmbientImageEnabled = (appCtx) => {
  return _.get(appCtx, 'siteConfig.toggles.isShopTheProjectAmbientImageEnabled', false);
};
